import { Flex, Image, Text } from '@chakra-ui/react'

import EMPTY_IMAGE from '../../assets/images/empty-news.svg'
import { useTranslation } from 'react-i18next'

const EmptyState = (): JSX.Element => {
    const { t } = useTranslation()
    return (
        <Flex direction={'column'} align={'center'} justify={'center'}>
            <Image src={EMPTY_IMAGE} alt={t('13262', 'No news yet')} />
            <Text
                fontSize={'16px'}
                fontWeight={'600'}
                color={'#0C0C0D'}
                lineHeight={'24px'}
                mt={'24px'}
                textAlign={'center'}
            >
                {t('13262', 'No news yet')}
            </Text>
            <Text
                fontSize={'14px'}
                fontWeight={'500'}
                color={'#4B4B4E'}
                lineHeight={'22px'}
                mt={'4px'}
                textAlign={'center'}
                letterSpacing={'0'}
            >
                {t('13263', 'Please check back later to see what\'s new')}
            </Text>
        </Flex>
    )
}

export default EmptyState
